import React, { useState, useEffect } from 'react';
import axios from 'axios';

const EgitimRaporuPage = () => {
  const [rapor, setRapor] = useState({ ozet: [], detay: [] });
  const [filtre, setFiltre] = useState({ egitim: '', durum: '', arama: '' });
  const [seciliEgitim, setSeciliEgitim] = useState(null);
  const [seciliPersonel, setSeciliPersonel] = useState(null);
  const [personelEgitimler, setPersonelEgitimler] = useState([]);
  const [personelYukleniyor, setPersonelYukleniyor] = useState(false);

  useEffect(() => {
    axios.get('/api/egitim/rapor/genel').then(res => setRapor(res.data)).catch(console.error);
  }, []);

  const fmt = t => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

  const durumBadge = (durum, bitis) => {
    if (durum === 'tamamlandi') return <span className="badge badge-tamamlandi">Tamamlandi</span>;
    if (bitis && new Date(bitis) < new Date()) return <span className="badge badge-hata">Suresi Gecti</span>;
    return <span className="badge badge-bekliyor">Devam Ediyor</span>;
  };

  const personelAc = async (personel) => {
    setSeciliPersonel(personel);
    setPersonelYukleniyor(true);
    try {
      const res = await axios.get('/api/egitim/personel/' + personel.kullanici_id);
      setPersonelEgitimler(res.data);
    } catch(err) { console.error(err); }
    finally { setPersonelYukleniyor(false); }
  };

  const toplamAtama = rapor.ozet.reduce((a, b) => a + (b.toplam_atama || 0), 0);
  const toplamTamamlanan = rapor.ozet.reduce((a, b) => a + (b.tamamlanan || 0), 0);
  const toplamGecen = rapor.ozet.reduce((a, b) => a + (b.suresi_gecen || 0), 0);

  // Personel egitim gecmisi sayfasi
  if (seciliPersonel) {
    const tamamlanan = personelEgitimler.filter(e => e.durum === 'tamamlandi').length;
    const devam = personelEgitimler.filter(e => e.durum !== 'tamamlandi').length;
    return (
      <div>
        <div style={{ marginBottom: '1.5rem' }}>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setSeciliPersonel(null); setPersonelEgitimler([]); }} style={{ marginBottom: '1rem' }}>← Geri</button>
          <h2 style={{ fontSize: '20px', marginBottom: '4px' }}>{seciliPersonel.ad} {seciliPersonel.soyad}</h2>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{seciliPersonel.email} — Egitim Gecmisi</p>
        </div>
        <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
          <div className="stat-kart"><div className="stat-sayi">{personelEgitimler.length}</div><div className="stat-etiket">Toplam</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{tamamlanan}</div><div className="stat-etiket">Tamamlandi</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{devam}</div><div className="stat-etiket">Devam Ediyor</div></div>
          <div className="stat-kart"><div className="stat-sayi">{personelEgitimler.filter(e => e.sertifika_adi).length}</div><div className="stat-etiket">Sertifika</div></div>
        </div>
        {personelYukleniyor ? (
          <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Yukleniyor...</div>
        ) : personelEgitimler.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '2rem', color: 'var(--yazi-ikincil)' }}>Bu personele atanmis egitim bulunmuyor.</div>
        ) : (
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div className="tablo-wrapper">
              <table>
                <thead>
                  <tr><th>Egitim</th><th>Durum</th><th>Atanma</th><th>Bitis</th><th>Tamamlandi</th><th>Sertifika</th></tr>
                </thead>
                <tbody>
                  {personelEgitimler.map(eg => (
                    <tr key={eg.id}>
                      <td style={{ fontWeight: '500' }}>{eg.egitim_adi}</td>
                      <td>{durumBadge(eg.durum, eg.bitis_tarihi)}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(eg.atama_tarihi)}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(eg.bitis_tarihi)}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(eg.tamamlanma_tarihi)}</td>
                      <td>
                        {eg.sertifika_adi ? (
                          <a href={'/api/egitim/sertifika/' + eg.id} target="_blank" rel="noreferrer"
                            className="btn btn-secondary btn-sm">
                            🏆 Indir
                          </a>
                        ) : <span style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>—</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }

    // Egitim detay sayfasi
  if (seciliEgitim) {
    const egitimDetay = rapor.detay.filter(d => d.egitim_adi === seciliEgitim.egitim_adi);
    const tamamlanan = egitimDetay.filter(d => d.durum === 'tamamlandi').length;
    const devam = egitimDetay.filter(d => d.durum !== 'tamamlandi').length;
    const oran = egitimDetay.length > 0 ? Math.round(tamamlanan / egitimDetay.length * 100) : 0;

    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.5rem' }}>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => setSeciliEgitim(null)}>← Geri</button>
          <div>
            <h2 style={{ fontSize: '22px', marginBottom: '2px' }}>{seciliEgitim.egitim_adi}</h2>
            <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>{seciliEgitim.sure_gun > 0 ? seciliEgitim.sure_gun + ' gunluk egitim' : 'Suresiz egitim'}</p>
          </div>
        </div>

        <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
          <div className="stat-kart"><div className="stat-sayi">{egitimDetay.length}</div><div className="stat-etiket">Toplam Atama</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{tamamlanan}</div><div className="stat-etiket">Tamamlandi</div></div>
          <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{devam}</div><div className="stat-etiket">Devam Ediyor</div></div>
          <div className="stat-kart">
            <div className="stat-sayi">{oran}%</div>
            <div className="stat-etiket">Tamamlanma</div>
            <div style={{ height: '4px', background: 'var(--gri-100)', borderRadius: '2px', marginTop: '6px' }}>
              <div style={{ height: '100%', background: oran >= 80 ? 'var(--yesil)' : oran >= 40 ? '#f59e0b' : 'var(--mavi)', borderRadius: '2px', width: oran + '%' }} />
            </div>
          </div>
        </div>

        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '600' }}>Atanan Personeller</h3>
            <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>Personele tiklayarak egitim gecmisini goruntuleyebilirsiniz.</p>
          </div>
          <div className="tablo-wrapper">
            <table>
              <thead>
                <tr><th>Personel</th><th>Durum</th><th>Atanma</th><th>Bitis</th><th>Tamamlanma</th><th>Sertifika</th></tr>
              </thead>
              <tbody>
                {egitimDetay.length === 0 && (
                  <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--yazi-ikincil)', padding: '2rem' }}>Kayit bulunamadi.</td></tr>
                )}
                {egitimDetay.map(d => (
                  <tr key={d.id} style={{ cursor: 'pointer' }} onClick={() => personelAc(d)}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div className="avatar" style={{ width: '28px', height: '28px', fontSize: '11px', flexShrink: 0 }} data-harf={d.ad[0] || '?'}>{d.ad[0]}{d.soyad[0]}</div>
                        <div>
                          <div style={{ fontWeight: '500', fontSize: '14px', color: 'var(--mavi)' }}>{d.ad} {d.soyad} →</div>
                          <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{d.email}</div>
                        </div>
                      </div>
                    </td>
                    <td>{durumBadge(d.durum, d.bitis_tarihi)}</td>
                    <td style={{ fontSize: '13px' }}>{fmt(d.atama_tarihi)}</td>
                    <td style={{ fontSize: '13px' }}>{fmt(d.bitis_tarihi)}</td>
                    <td style={{ fontSize: '13px' }}>{fmt(d.tamamlanma_tarihi)}</td>
                    <td>{d.sertifika_adi ? <span style={{ fontSize: '12px', color: 'var(--yesil)' }}>🏆 Var</span> : <span style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>—</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  // Ana rapor sayfasi
  const filtrelenmis = rapor.detay.filter(d => {
    const aramaEsles = !filtre.arama || (d.ad + ' ' + d.soyad + ' ' + d.email).toLowerCase().includes(filtre.arama.toLowerCase());
    const egitimEsles = !filtre.egitim || d.egitim_adi === filtre.egitim;
    const durumEsles = !filtre.durum || d.durum === filtre.durum;
    return aramaEsles && egitimEsles && durumEsles;
  });

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Egitim Raporu</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Egitim tamamlanma durumlari ve istatistikler.</p>
      </div>

      <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="stat-kart"><div className="stat-sayi">{toplamAtama}</div><div className="stat-etiket">Toplam Atama</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{toplamTamamlanan}</div><div className="stat-etiket">Tamamlanan</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--kirmizi)' }}>{toplamGecen}</div><div className="stat-etiket">Suresi Gecen</div></div>
        <div className="stat-kart"><div className="stat-sayi">{toplamAtama > 0 ? Math.round(toplamTamamlanan / toplamAtama * 100) : 0}%</div><div className="stat-etiket">Tamamlanma Orani</div></div>
      </div>

      {rapor.ozet.length > 0 && (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '600' }}>Egitim Bazli Ozet</h3>
            <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>Egitime tiklayarak atanan personelleri goruntuleyin.</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1rem' }}>
            {rapor.ozet.map((o, i) => {
              const oran = o.toplam_atama > 0 ? Math.round((o.tamamlanan || 0) / o.toplam_atama * 100) : 0;
              return (
                <div key={i} style={{ border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '1rem', cursor: 'pointer', transition: 'all 0.2s' }}
                  onClick={() => setSeciliEgitim(o)}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = 'var(--shadow-md)'; e.currentTarget.style.borderColor = 'var(--mavi)'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = 'var(--border)'; }}>
                  <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '8px' }}>{o.egitim_adi}</div>
                  <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: 'var(--yazi-ikincil)', marginBottom: '10px' }}>
                    <span>👥 {o.toplam_atama || 0}</span>
                    <span style={{ color: 'var(--yesil)' }}>✅ {o.tamamlanan || 0}</span>
                    {o.suresi_gecen > 0 && <span style={{ color: 'var(--kirmizi)' }}>⚠️ {o.suresi_gecen}</span>}
                  </div>
                  <div style={{ height: '6px', background: 'var(--gri-100)', borderRadius: '3px', marginBottom: '4px' }}>
                    <div style={{ height: '100%', borderRadius: '3px', width: oran + '%', background: oran >= 80 ? 'var(--yesil)' : oran >= 40 ? '#f59e0b' : 'var(--mavi)' }} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--yazi-ikincil)' }}>
                    <span>{oran}% tamamlandi</span>
                    <span style={{ color: 'var(--mavi)' }}>Detay →</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: '14px', fontWeight: '600', marginRight: '8px' }}>Tum Atamalar</span>
          <input type="text" placeholder="Isim veya email ara..." value={filtre.arama} onChange={e => setFiltre({ ...filtre, arama: e.target.value })} style={{ flex: 1, minWidth: '160px' }} />
          <select value={filtre.egitim} onChange={e => setFiltre({ ...filtre, egitim: e.target.value })} style={{ minWidth: '160px' }}>
            <option value="">Tum Egitimler</option>
            {rapor.ozet.map((o, i) => <option key={i} value={o.egitim_adi}>{o.egitim_adi}</option>)}
          </select>
          <select value={filtre.durum} onChange={e => setFiltre({ ...filtre, durum: e.target.value })} style={{ minWidth: '140px' }}>
            <option value="">Tum Durumlar</option>
            <option value="atandi">Devam Ediyor</option>
            <option value="tamamlandi">Tamamlandi</option>
          </select>
        </div>
        <div className="tablo-wrapper">
          <table>
            <thead>
              <tr><th>Personel</th><th>Egitim</th><th>Durum</th><th>Atanma</th><th>Bitis</th><th>Tamamlandi</th></tr>
            </thead>
            <tbody>
              {filtrelenmis.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--yazi-ikincil)', padding: '2rem' }}>Kayit bulunamadi.</td></tr>
              )}
              {filtrelenmis.map(d => (
                <tr key={d.id} style={{ cursor: 'pointer' }} onClick={() => personelAc(d)}>
                  <td>
                    <div style={{ fontWeight: '500', fontSize: '14px', color: 'var(--mavi)' }}>{d.ad} {d.soyad} →</div>
                    <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{d.email}</div>
                  </td>
                  <td style={{ fontSize: '13px' }}>{d.egitim_adi}</td>
                  <td>{durumBadge(d.durum, d.bitis_tarihi)}</td>
                  <td style={{ fontSize: '13px' }}>{fmt(d.atama_tarihi)}</td>
                  <td style={{ fontSize: '13px' }}>{fmt(d.bitis_tarihi)}</td>
                  <td style={{ fontSize: '13px' }}>{fmt(d.tamamlanma_tarihi)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default EgitimRaporuPage;
